module.exports = __webpack_public_path__ + "img/mainboard_cover_b.086fc02e.png";